import React from 'react';
import { Button } from '../../../components/ui/Button';
import { cn } from '@/lib/utils';

type Props = {
  onSkip: () => void;
  isSkipping?: boolean;
  skipLabel?: string;
  onBack?: () => void;
  backLabel?: string;
  className?: string;
};

const OnboardingStepFooter: React.FC<Props> = ({
  onSkip,
  isSkipping = false,
  skipLabel = 'Pular etapa',
  onBack,
  backLabel = 'Voltar',
  className,
}) => (
  <div
    className={cn(
      onBack
        ? 'mt-s4 flex items-center justify-between gap-s2 border-t border-border pt-s3 sm:mt-s6 sm:pt-s4'
        : 'mt-s4 flex justify-end border-t border-border pt-s3 sm:mt-s6 sm:pt-s4',
      className,
    )}
  >
    {onBack && (
      <Button
        type="button"
        variant="ghost"
        className="min-h-11 touch-manipulation text-sm"
        onClick={onBack}
      >
        {backLabel}
      </Button>
    )}
    <Button
      type="button"
      variant="ghost"
      className="min-h-11 touch-manipulation text-sm"
      onClick={onSkip}
      disabled={isSkipping}
    >
      {isSkipping ? 'Pulando...' : skipLabel}
    </Button>
  </div>
);

export default OnboardingStepFooter;
